var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SpinnerContainer"},[(_vm.isOpen)?_c('span',{staticClass:"Spinner"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }